import type { ProjectAccessVerdict, ProjectAccessVerdictCan } from "@/api/index.d";

/** Client presentation state only; never part of the API wire contract. */
export type ProvisionalProjectAccessVerdict = ProjectAccessVerdict & { provisional: true };
export type ClientProjectAccessVerdict = ProjectAccessVerdict & { provisional?: true };

export const OWNER_CAN: ProjectAccessVerdictCan = {
	view: true,
	addContent: true,
	editContent: true,
	ownUploadsOnly: false,
	editDetails: true,
	manageChecklists: true,
	editChecklistItems: true,
	manageAccess: true,
	readRoster: true,
	delete: true,
	requestReview: true,
	assignSessions: true,
	requestEditAccess: false
};

/** UI-only recovery for a creator in their current organization; never cached as a server verdict. */
export function provisionalOwnerVerdict(
	entity: { createdBy?: string; organizationId?: string } | undefined,
	me: { user?: { id?: string }; organization?: { id?: string } } | null,
	access: { transientFailure: boolean; verdict?: ProjectAccessVerdict },
	isAuthenticated: boolean
): ProvisionalProjectAccessVerdict | undefined {
	if (
		access.verdict !== undefined ||
		!isAuthenticated ||
		!access.transientFailure ||
		!me?.user?.id ||
		!me.organization?.id ||
		entity?.createdBy !== me.user.id ||
		entity.organizationId !== me.organization.id
	)
		return undefined;
	return {
		hasAccess: true,
		origin: "owner",
		accessType: "editor",
		differentOrg: false,
		isExternalEditor: false,
		provisional: true,
		can: { ...OWNER_CAN }
	};
}
